import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const radioOnlyIconFn = /* @__PURE__ */ createRecipe('radi-icon', {}, [])

const radioOnlyIconVariantMap = {
  "color": [
    "danger"
  ]
}

const radioOnlyIconVariantKeys = Object.keys(radioOnlyIconVariantMap)

export const radioOnlyIcon = /* @__PURE__ */ Object.assign(memo(radioOnlyIconFn.recipeFn), {
  __recipe__: true,
  __name__: 'radioOnlyIcon',
  __getCompoundVariantCss__: radioOnlyIconFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: radioOnlyIconVariantKeys,
  variantMap: radioOnlyIconVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, radioOnlyIconVariantKeys)
  },
  getVariantProps: radioOnlyIconFn.getVariantProps,
})